import { queryOptions } from "@tanstack/react-query";

import { getSchoolYearTerms } from "@/lib/school-calendar.functions";

/** Läsårstiderna som visas publikt, per språk. */
export function schoolTermsQuery(locale: "sv" | "en" | "es") {
  return queryOptions({
    queryKey: ["school-terms", locale],
    queryFn: () => getSchoolYearTerms({ data: { locale } }),
    staleTime: 60 * 1000,
  });
}
